// src/teamPlan/teamPlan.ts
var TeamPlanUsageCapType = /* @__PURE__ */ ((TeamPlanUsageCapType2) => {
  TeamPlanUsageCapType2[TeamPlanUsageCapType2["AutoScale"] = 0] = "AutoScale";
  TeamPlanUsageCapType2[TeamPlanUsageCapType2["Capped"] = 1] = "Capped";
  return TeamPlanUsageCapType2;
})(TeamPlanUsageCapType || {});
var TeamPlanTier = /* @__PURE__ */ ((TeamPlanTier2) => {
  TeamPlanTier2[TeamPlanTier2["FREE"] = 0] = "FREE";
  TeamPlanTier2[TeamPlanTier2["GROWTH"] = 1] = "GROWTH";
  TeamPlanTier2[TeamPlanTier2["ENTERPRISE"] = 2] = "ENTERPRISE";
  TeamPlanTier2[TeamPlanTier2["OTHER"] = 3] = "OTHER";
  TeamPlanTier2[TeamPlanTier2["SCALE"] = 4] = "SCALE";
  TeamPlanTier2[TeamPlanTier2["PAYG"] = 5] = "PAYG";
  return TeamPlanTier2;
})(TeamPlanTier || {});
var TeamPlanTerm = /* @__PURE__ */ ((TeamPlanTerm2) => {
  TeamPlanTerm2[TeamPlanTerm2["MONTHLY"] = 0] = "MONTHLY";
  TeamPlanTerm2[TeamPlanTerm2["ANNUAL"] = 1] = "ANNUAL";
  return TeamPlanTerm2;
})(TeamPlanTerm || {});
var PLAN_TIER_FCUPS_LIMIT = {
  [0 /* FREE */]: 500,
  [1 /* GROWTH */]: 6e3,
  [4 /* SCALE */]: 6e3,
  [2 /* ENTERPRISE */]: 2e4,
  [3 /* OTHER */]: 2e4,
  [5 /* PAYG */]: 1e4
};
var PLAN_TIER_APP_LIMIT = {
  [0 /* FREE */]: 5,
  [1 /* GROWTH */]: 15,
  [4 /* SCALE */]: 30,
  [2 /* ENTERPRISE */]: 100,
  [3 /* OTHER */]: 100,
  [5 /* PAYG */]: 30
};
var PLAN_TIER_LABELS = {
  [0 /* FREE */]: "Free",
  [1 /* GROWTH */]: "Growth",
  [4 /* SCALE */]: "Scale",
  [2 /* ENTERPRISE */]: "Enterprise",
  [3 /* OTHER */]: "Enterprise Trial",
  [5 /* PAYG */]: "Pay As You Go"
};
var STRIPE_AUTHORIZATION_AMOUNT = 4900;

export {
  TeamPlanUsageCapType,
  TeamPlanTier,
  TeamPlanTerm,
  PLAN_TIER_FCUPS_LIMIT,
  PLAN_TIER_APP_LIMIT,
  PLAN_TIER_LABELS,
  STRIPE_AUTHORIZATION_AMOUNT
};
//# sourceMappingURL=chunk-6Y7WYS3M.mjs.map